import 'unfetch/polyfill';
import {
  AUTH_ERROR,
  AUTH_CHECK,
  AUTH_GET_PERMISSIONS,
  AUTH_LOGOUT,
  // GET_LIST,
} from 'admin-on-rest';

import utils from './utils/auth-utils';
import { loadJSON } from './utils/localStorage';


export default async (type, params = {}, apiUrl) => {
  console.log(type, params, apiUrl);
  if (process.env.NODE_ENV === 'development') {
    const perms = loadJSON('permissions');
    return Promise.resolve(perms);
  }
  switch (type) {
    case AUTH_LOGOUT: {
      localStorage.removeItem('user');
      localStorage.removeItem('permissions');
      return utils.signOut();
    }
    case AUTH_CHECK: {
      try {
        return utils.check();
      } catch (error) {
        return Promise.reject();
      }
    }
    case AUTH_GET_PERMISSIONS: {
      const perms = loadJSON('permissions');
      // causes unhelpful uncaught in promise error when sent to aor
      if (!perms) {
        return Promise.reject();
      }
      console.log('auth-get-permissions found permissions', perms);
      return Promise.resolve(perms);
    }
    case AUTH_ERROR: {
      const { status } = params;
      if (status === 401 || status === 403) {
        console.error(params);
        localStorage.removeItem('permissions');
        localStorage.removeItem('user');
        await utils.signOut();
        return Promise.reject();
      }
      return Promise.resolve();
    }
    default:
      return Promise.reject('Unkown method');
  }
};
